<script setup lang="ts">
import SiteHeader from '@components/layout/site-header';
import SiteFooter from '@components/layout/site-footer';
import useExtraScript from '@composable/useExtraScript';

defineProps<{ showDrawer?: boolean }>();
const { isMrbilit } = useWhiteLabel();
useExtraScript();
const route = useRoute();
</script>

<template>
    <div>
        <SiteHeader
            :show-drawer
            overlay-header-in-desktop
            mobile-background-color="var(--blue-400)"
        />
        <slot />
        <SiteFooter :is-home-page="route.path === '/'" />
        <VitePwaManifest v-if="isMrbilit" />
    </div>
</template>
